export function specialistSalesReportListResponse(json, headers) {
  console.log(json);
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function specialistSalesReportMapperGetOneResponse(json) {
  return {
    data: {
      ...json.result,
      id: json.result.objectId,
    },
  };
}
export function fixGetManySpecialistSalesReport(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
    })),
  };
}
